export const AppleMusicCard = ({ url, meta, postId }) => {
  // Convert Apple Music URL to embed URL
  // https://music.apple.com/fr/album/xxx/123?i=456 -> https://embed.music.apple.com/fr/album/xxx/123?i=456
  const embedUrl = url.replace("https://music.apple.com", "https://embed.music.apple.com");

  if (url.includes("music.apple.com")) {
    return (
      <div className="mt-3 rounded-2xl overflow-hidden w-full max-w-full" data-testid={`apple-card-${postId}`}>
        <iframe
          src={embedUrl}
          width="100%"
          height="175"
          frameBorder="0"
          allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
          sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
          loading="lazy"
          className="rounded-2xl"
          title="Apple Music"
          style={{ maxWidth: "100%", background: "transparent" }}
        />
      </div>
    );
  }

  // Fallback card
  if (meta && meta.thumbnail_url) {
    return (
      <div className="mt-3 flex items-center gap-3 bg-[#FC3C44]/10 border border-[#FC3C44]/30 rounded-2xl p-3 w-full max-w-full" data-testid={`apple-card-${postId}`}>
        <img src={meta.thumbnail_url} alt="" className="w-12 h-12 sm:w-16 sm:h-16 rounded-xl object-cover shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground truncate">{meta.title}</p>
          <p className="text-xs text-muted-foreground mt-0.5">Apple Music</p>
        </div>
      </div>
    );
  }
  return null;
};
